<template>
  <b-container>
    <b-form-group
      id="configHideScheduleFieldset"
      label-cols="2"
      label="Hide Schedule?"
      label-class="pt-0"
      label-for="configHideSchedule"
      description="Hide the Scores/Schedule module">
      <b-form-checkbox
        id="configHideSchedule"
        v-model.number="hideSchedule"
        name="configHideSchedule"
        value="1"
        unchecked-value="0" />
    </b-form-group>

    <b-form-group
      id="configUsePostseasonScheduleFieldset"
      label-cols="2"
      label="Use Postseason Schedule?"
      label-class="pt-0"
      label-for="configUsePostseasonSchedule"
      description="Reduces number of date blocks on schedule module from 5 to 4 for Postseason">
      <b-form-checkbox
        id="configUsePostseasonSchedule"
        v-model="usePostseasonSchedule"
        name="configUsePostseasonSchedule"
        :value="true"
        :unchecked-value="false" />
    </b-form-group>

    <b-form-group
      id="configShowSeriesStatusRowFieldset"
      label-cols="2"
      label="Show Series Status Row?"
      label-class="pt-0"
      label-for="configShowSeriesStatusRow"
      description="Creates row beneath date blocks with series status text">
      <b-form-checkbox
        id="configShowSeriesStatusRow"
        v-model.number="showSeriesStatusRow"
        name="configShowSeriesStatusRow"
        :value="true"
        :unchecked-value="false" />
    </b-form-group>

    <b-form-group
      id="configHideTicketsGamesFieldset"
      label-cols="2"
      label="Hide Ticket Games?"
      label-class="pt-0"
      label-for="configHideTicketsGames"
      description="Hide the tickets module">
      <b-form-checkbox
        id="configHideTicketsGames"
        v-model.number="hideTicketsGames"
        name="configHideTicketsGames"
        value="1"
        unchecked-value="0" />
    </b-form-group>

    <b-form-group
      id="configStatsModeFieldset"
      label-cols="2"
      label="Stats Mode"
      label-for="configStatsMode"
      description="Set the type of stats to display by default">
      <b-form-select v-model.number="statsMode">
        <option value="0">
          Spring Training
        </option>
        <option value="1">
          Regular Season
        </option>
        <option value="2">
          Postseason
        </option>
      </b-form-select>
    </b-form-group>

    <b-form-group
      id="configStatsSeasonFieldset"
      label-cols="2"
      label="Stats Season"
      label-for="configStatsSeason"
      description="Set the year to display by default in the Stats module">
      <b-form-input v-model.number="statsSeason" />
    </b-form-group>

    <b-form-group
      id="configHideMoreInfoScheduleFieldset"
      label-cols="2"
      label="Hide 'More Info' Schedule menu?"
      label-class="pt-0"
      label-for="configHideMoreInfoSchedule"
      description="Hide the 'More Info' Schedule menu for the configured year, used in off-season to show next year's schedule">
      <b-form-checkbox
        id="configHideMoreInfoSchedule"
        v-model.number="hideMoreInfoSchedule"
        name="configHideMoreInfoSchedule"
        value="1"
        unchecked-value="0" />
    </b-form-group>

    <b-form-group
      id="configMoreInfoScheduleMonthFieldset"
      label-cols="2"
      label="More Info Schedule Month"
      label-for="configMoreInfoScheduleMonth"
      description="Set the month to display by default in the Stats module">
      <b-form-input v-model.number="moreInfoScheduleMonth" />
    </b-form-group>

    <b-form-group
      id="configMoreInfoScheduleYearFieldset"
      label-cols="2"
      label="More Info Schedule Year"
      label-for="configMoreInfoScheduleYear"
      description="Set the year to display by default in the Stats module">
      <b-form-input v-model.number="moreInfoScheduleYear" />
    </b-form-group>

    <b-form-group
      id="configHideMoreInfoResultsFieldset"
      label-cols="2"
      label="Hide 'More Info' Results?"
      label-class="pt-0"
      label-for="configHideMoreInfoResults"
      description="Hide the 'More Info' Results menu for the configured year, used in off-season to show previous year's results">
      <b-form-checkbox
        id="configHideMoreInfoResults"
        v-model.number="hideMoreInfoResults"
        name="configHideMoreInfoResults"
        value="1"
        unchecked-value="0" />
    </b-form-group>

    <b-form-group
      id="configMoreInfoResultsMonthFieldset"
      label-cols="2"
      label="More Info Results Month"
      label-for="configMoreInfoResultsMonth"
      description="Set the month to display by default in the Stats module">
      <b-form-input v-model.number="moreInfoResultsMonth" />
    </b-form-group>

    <b-form-group
      id="configMoreInfoResultsYearFieldset"
      label-cols="2"
      label="More Info Results Year"
      label-for="configMoreInfoResultsYear"
      description="Set the year to display by default in the Stats module">
      <b-form-input v-model.number="moreInfoResultsYear" />
    </b-form-group>

    <b-form-group
      id="configMoreInfoBallparkIdFieldset"
      label-cols="2"
      label="More Info Venue ID"
      label-for="configMoreInfoBallparkId"
      description="Venue ID of the 'More Info' Ballpark menu link (used for app switching)">
      <b-form-input v-model.number="moreInfoBallparkId" />
    </b-form-group>

    <b-form-group
      name="configMoreInfoBallparkNameFieldset"
      label-cols="2"
      label="More Info Ballpark Name"
      label-for="configMoreInfoBallparkName"
      description="Venue Name displayed for the 'More Info' Ballpark menu">
      <b-form-input v-model="moreInfoBallparkName" />
    </b-form-group>
  </b-container>
</template>

<script>
  import { createHelpers } from 'vuex-map-fields'

  const { mapFields } = createHelpers({
      getterType: 'getIosConfigField',
      mutationType: 'updateIosConfigField',
  })

  export default {
    name: 'TeamMashupIosConfig',
    computed: {
      ...mapFields([
          'hideSchedule',
          'usePostseasonSchedule',
          'showSeriesStatusRow',
          'hideTicketsGames',
          'statsMode',
          'statsSeason',
          'hideMoreInfoSchedule',
          'moreInfoScheduleMonth',
          'moreInfoScheduleYear',
          'hideMoreInfoResults',
          'moreInfoResultsMonth',
          'moreInfoResultsYear',
          'moreInfoBallparkId',
          'moreInfoBallparkName',
      ]),
    },
  }
</script>
